import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'grid-header-sortable',
    templateUrl: './grid-header-sortable.component.html',
    styleUrls: ['./grid-header-sortable.component.scss'],
    imports: [NgClass]
})
export class GridHeaderSortableComponent {
	@Input() isSorted: boolean = false;
	@Input() sortOrder: 'asc' | 'desc';
}
